'use client'
import { GET_PROFILE_QUERY_KEY } from '@partment/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'
import { getProfile } from '..'

export const useProfileMe = () => {
  const { data: session, status } = useSession()

  const {
    data: userData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [GET_PROFILE_QUERY_KEY],
    queryFn: getProfile,
    enabled: status === 'authenticated' && Boolean(session?.access_token),
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
  return { data: userData, isLoading, isError }
}
